"use client";

import {
	Chip as DSChip,
	Text,
	type ChipProps
} from "@pamperedchef/design-system";
import { type FC } from "react";
import * as styles from "./stubs.module.scss";

// DS `.d.ts` types `Chip` as its raw `(props, ref)` render function rather than
// a forwardRef component, so JSX rejects it — cast to a component type (same
// workaround the repo uses for `Breadcrumb`/`Col`).
const Chip = DSChip as unknown as FC<ChipProps>;

const POPULAR = [
	"Stoneware",
	"Dutch Ovens",
	"Skillets & Fry Pans",
	"Stainless Steel",
	"Grill Pans",
	"Bakeware"
];

export interface PlpPopularFiltersProps {
	/** Placeholder chip labels. */
	labels?: string[];
}

/** STUB popular-filters row — DS `Chip`s in a horizontal strip. */
export function PlpPopularFilters({
	labels = POPULAR
}: PlpPopularFiltersProps): JSX.Element {
	return (
		<section
			className={styles["stackXs"]}
			data-component="PlpPopularFilters"
		>
			<Text
				tag="span"
				styledAs="smb"
			>{`Popular Filters (${labels.length})`}</Text>
			<div className={styles["chipRow"]}>
				{labels.map((label) => (
					<Chip key={label} label={label} kind="outline" size="md" />
				))}
			</div>
		</section>
	);
}
